import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AgreementsService } from 'api';
import { getAgreementAtom, getAgreementByIdRequestIdState } from 'api/agreements/getAgreementById';
import { getAgreementsRequestIdState } from 'api/agreements/getAgreementsAndVehicle';
import AddressTypes from 'constants/addressTypes';
export default function useAgreementAddress() {
  const {
    agreementId
  } = useParams();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [agreement, setAgreement] = useRecoilState(getAgreementAtom(agreementId));
  const [requestId, setRequestId] = useRecoilState(getAgreementsRequestIdState);
  const [agreementIdRequestId, setAgreementIdRequestId] = useRecoilState(getAgreementByIdRequestIdState);
  const changeAgreementAddress = async (addressType, address) => {
    if (agreement && agreementId) {
      try {
        setIsLoading(true);
        const billingAddressBody = {
          [addressType]: address,
          name: agreement.name,
          shippingAddress: agreement.shippingAddress
        };
        const shippingAddressBody = {
          [addressType]: address,
          name: agreement.name,
          billingAddress: agreement.billingAddress
        };
        const agreementObject = await AgreementsService.editAgreement({
          agreementId,
          body: addressType === AddressTypes.BILLING ? billingAddressBody : shippingAddressBody
        });
        if (agreementObject) {
          setAgreement(agreementObject);
          setRequestId(requestId + 1);
          setAgreementIdRequestId(agreementIdRequestId + 1);
        }
      } catch (e) {
        if (!axios.isCancel(e)) enqueueSnackbar(t('error.edit_address'), {
          variant: 'error'
        });
      } finally {
        setIsLoading(false);
      }
    }
  };
  return {
    isLoading,
    changeAgreementAddress
  };
}